import { render, staticRenderFns } from "./SectorVolume.vue?vue&type=template&id=05bfd3b6&"
import script from "./SectorVolume.vue?vue&type=script&lang=js&"
export * from "./SectorVolume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports